import React, { FC } from 'react';

import Spinner from './Spinner';

const SpinnerPageLoad: FC = () => <Spinner backgroundLayout verticallyCentered />;

export default SpinnerPageLoad;
